import React from "react";
import { joinComponents } from "utilities/reactUtils";

interface Props<T> {
  items: T[]
  renderItem: (item: T) => React.ReactNode
  renderExcess: (nrOfItemsPastLimit: number) => React.ReactNode
  limit: number
  delimiter: string
}

// This component renders a list of items, but limits the number of items that are rendered
// So you can easily render a list like: "Item1, Item2, Item3, +2 more"
const LimitedList = <T extends unknown>({ items, renderItem, renderExcess, limit, delimiter }: Props<T>) => {
  const renderedComponents = items.slice(0, limit).map((item) => renderItem(item));
  const joinedComponents = joinComponents(renderedComponents, delimiter);

  const nrOfItemsPastLimit = items.length - limit;

  return <React.Fragment>
    {joinedComponents}
    {nrOfItemsPastLimit > 0 && renderExcess(nrOfItemsPastLimit)}
  </React.Fragment>;
};

export default LimitedList;